import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ToastContainerComponent, AppStatusComponent } from '@zag/ui';

/**
 * Minimal layout component for users with no permissions or permission errors.
 * Shows only the content area with no sidebar or header bar.
 * The logo is displayed inside the content (e.g., in the pending-access card).
 * Used for the pending-access and permission-error pages.
 */
@Component({
  selector: 'sc-minimal-layout',
  imports: [RouterModule, ToastContainerComponent, AppStatusComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="minimal-layout">
      <div class="minimal-layout__content">
        <router-outlet />
      </div>

      <footer class="minimal-layout__footer">
        <zag-app-status />
      </footer>

      <!-- Toast Notifications -->
      <zag-toast-container />
    </div>
  `,
  styles: [
    `
      .minimal-layout {
        display: flex;
        flex-direction: column;
        min-height: 100vh;
        min-height: 100svh;
        background: var(--background-color-secondary);
      }

      .minimal-layout__content {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: var(--spacing-lg, 24px);
      }

      .minimal-layout__footer {
        flex-shrink: 0;
        display: flex;
        justify-content: center;
        padding: var(--spacing-md, 16px);
      }
    `,
  ],
})
export class MinimalLayoutComponent {}
